import './AppTile.scss';
import { Icon } from '@gplibraries/react/components';
import { Link } from 'react-router';

interface AppTileProps {
  title: string;
  href: string;
  icon: string;
  external: boolean;
}
export default function AppTile({title, href, icon, external = false}: AppTileProps) {

  return (
      <Link to={href ?? '/'} reloadDocument={external} className={'no-underline'}>
        <div className={'app-tile block border'}>

          <div className="tile-content">
            {icon ? icon : <Icon glyph={'window'}/>}
            <div className="app-title">{title ?? ''}</div>
          </div>

        </div>
      </Link>
  );
}